// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"d3ae7f09","787":"3e21a6d3"}[chunkId] + ".chunk.js";
};